module.exports = __webpack_public_path__ + "static/media/letters2.8799ceb2.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/static/letters2.jpeg
// module id = 519
// module chunks = 0